/**
 * Hotjar Survey Trigger
 * Automatically triggers Hotjar surveys based on scroll position or immediately
 */

export function initHotjar(): void {
    const hotjarFeedbackButtons = document.querySelectorAll('.hotjar-auto-scroll');

    hotjarFeedbackButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const closestSurveyElementOnPage = document.querySelectorAll('._hj-widget-container');
            // console.log('Hotjar feedback button clicked');
            if (closestSurveyElementOnPage.length > 0) {
                // If the Hotjar widget is already present, do nothing
                const element = closestSurveyElementOnPage[0] as HTMLElement;

                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        });
    });
}
